import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    access_token: null,
  },

  getters: {
    getAccessToken: (state) => state.access_token,
    isAuthenticated: (state) => !!state.access_token,
  },

  mutations: {
    SET_ACCESS_TOKEN(state, token) {
      state.access_token = token;
    },
    CLEAR_AUTH(state) {
      state.access_token = null;
    },
  },

  actions: {
    saveUserData({ commit }, { access_token }) {
      commit("SET_ACCESS_TOKEN", access_token);
    },
    logout({ commit }) {
      commit("CLEAR_AUTH");
    },
  },

  plugins: [createPersistedState()],
});
